type TBPModes = 'onboard' | 'edit' | 'add';

// Helper to determine which "mode" of tbp is required given an input
// url path
export const matchTbpMode = (url: string): TBPModes | void => {
	// Named capture groups:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Groups_and_Ranges
	const match = url.match(/\/property\/.*?\/(?<mode>[a-z]+)/);
	const mode = match?.groups?.mode;
	if (!!mode && ['onboard', 'edit', 'add'].includes(mode)) {
		return mode as TBPModes;
	}
};

/**
 * In cases where a user lands on the "no-mode" route for TBP (i.e. `/property/123456`),
 * we want to redirect them to `/edit` mode explicitly.
 * @param pathPropertyId {string} - The property ID that is being routed to.
 * @param pathname {string} - The full path of the route choice.
 * @returns {string} - The route to re-direct to.
 *
 * @example
 * // returns `/property/123456/edit/tasks/pricing
 * redirectPathToTBPEdit('123456', '/property/123456/tasks/pricing');
 */
export const redirectPathToTBPEdit = (pathPropertyId: string, pathname: string): string => {
	const nextUrlParts = pathname.split(pathPropertyId);
	return nextUrlParts[0] + `${pathPropertyId}` + '/edit' + (!!nextUrlParts[1] ? nextUrlParts[1] : '');
};
